import React from 'react';

import GroupIcon from '@mui/icons-material/Group';

import RelatedListCard from '../RelatedListCard';
import RelatedTileGrid from '../RelatedTileGrid';
import { RELATED_PREVIEW_LIMIT, accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';

import AccountRelatedContactTile from './AccountRelatedContactTile';
import { useAccountRelatedContacts } from './useAccountRelatedContacts';

interface Props {
  accountId: string;
}

export default function AccountRelatedContactsCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const { error, isLoading, relatedContacts } = useAccountRelatedContacts(accountId);

  return (
    <RelatedListCard
      count={relatedContacts.length}
      error={error}
      icon={<GroupIcon color="action" />}
      isLoading={isLoading}
      isSampleData
      title="Related Contacts"
      viewAllTo={accountPath(accountId, offerId, '/related-contacts')}
    >
      <RelatedTileGrid>
        {relatedContacts.slice(0, RELATED_PREVIEW_LIMIT).map((relatedContact) => (
          <AccountRelatedContactTile key={relatedContact.id} relatedContact={relatedContact} />
        ))}
      </RelatedTileGrid>
    </RelatedListCard>
  );
}
